const config = {

   //isProduction: false,   // ← UAT / Dev 就係 false
   isProduction: true, // ← 正式上線時改呢行為 true 就得！

  
  api: {
    //Production Environment 
    redirectBaseUrl: 'https://sb-epayment.wilsonparking.com.hk',
    baseUrl: 'https://sb-epayment.wilsonparking.com.hk/api/api', 


    //UAT Environment
    // redirectBaseUrl: 'https://www.ski-dev.com:13443',
     //baseUrl: 'https://www.ski-dev.com:13442/api', 
      
    //Development Environment
    // redirectBaseUrl: 'http://localhost:8443', 
    // baseUrl: 'http://localhost:5269/api', 
  
    endpoints: { 
      checkOrderStatus: '/check-order-status',
    },
  },
};

export default config;